<template>
  <modal-base
    ref="modal"
    :navigate="navigate"
    :title="'Edit ' + this.title"
    :width="1200"
    :full-height="true"
    :on-close-prompt="onClosePrompt"
    :on-close-clear-query="onCloseClearQuery"
    @close="$emit('close')"
  >
    <div class="modal_columns">
      <div class="modal_columns--form_column">
        <component ref="form" v-bind:is="formComponent" :form-data="formData"></component>

        <div class="flex flex-end mt-100" v-if="! hideSaveButton">
          <button-default @click="save" :loading="saving" :disabled="deleting || restoring">
            {{ saveButtonLabel }}
          </button-default>
        </div>

        <slot name="underForm"></slot>
      </div>

      <div class="modal_columns--slot_column">
        <slot></slot>
      </div>
    </div>

    <template v-slot:footer>
      <button-link
        class="mr-auto"
        color="is-danger"
        @click="deleteItem"
        :loading="deleting"
        :disabled="saving || restoring"
        v-if="! hideDeleteButton"
      >
        Delete
      </button-link>

      <button-link
        class="mr-auto"
        color="is-danger"
        @click="restoreItem"
        :loading="restoring"
        :disabled="saving || deleting"
        v-if="showRestoreButton"
      >
        Restore
      </button-link>
    </template>
  </modal-base>
</template>

<script>
import ModalBase from "./ModalBase";
import AccountForm from "../../forms/AccountForm";
import CampaignForm from "../../forms/CampaignForm";
import CallScriptForm from "../../forms/CallScriptForm";
import StatusForm from "../../forms/StatusForm";
import FollowUpTemplateForm from "../../forms/FollowUpTemplateForm";
import UserForm from "../../forms/UserForm";
import UserInviteForm from "../../forms/UserInviteForm";
import WebhookForm from "../../forms/WebhookForm";
import ContactTypeForm from "../../forms/ContactTypeForm";
import ShareableGroupForm from "../../forms/ShareableGroupForm";
import TaskListForm from "../../forms/TaskListForm.vue";

export default {
   name: "ModalFormEdit",
  components: {
    ModalBase,
    AccountForm,
    CampaignForm,
    CallScriptForm,
    StatusForm,
    FollowUpTemplateForm,
    UserForm,
    UserInviteForm,
    WebhookForm,
    ContactTypeForm,
    ShareableGroupForm,
    TaskListForm,
  },
  props: {
    title: {
      type: String,
      required: true
    },
    formComponent: {
      required: true
    },
    navigate: {
      type: String,
      required: false,
    },
    saveButtonLabel: {
      type: String,
      default: 'Save'
    },
    hideSaveButton: {
      type: Boolean,
      default: false
    },
    hideDeleteButton: {
      type: Boolean,
      default: false
    },
    showRestoreButton: {
      type: Boolean,
      default: false
    },
    onClosePrompt: {
      type: Function,
      required: false,
    },
    onCloseClearQuery: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      saving: false,
      deleting: false,
      restoring: false,
      formData: null,
    }
  },
  methods: {
    deleteItem() {
      this.deleting = true;
      return this.$refs.form.delete()
        .then(() => {
          this.$emit('deleted', this.formData)
          this.close();
        })
        .finally(() => this.deleting = false);
    },
    restoreItem() {
      this.restoring = true;
      return this.$refs.form.restore()
        .then(() => {
          this.$emit('restored', this.formData)
          this.close();
        })
        .finally(() => this.restoring = false);
    },
    save() {
      this.saving = true;
      return this.$refs.form.save()
        .then((response) => {
          this.$emit('updated', response.data)
          this.$emit('saved', response.data)

          return response;
        })
        .finally(() => this.saving = false);
    },
    open(formData = null) {
      this.formData = formData;
      this.$refs.modal.open();
      this.$emit('open', formData)
    },
    close() {
      this.$refs.modal.close();
      this.$emit('close', this.formData)
      this.formData = null;

      if (this.navigate) {
        this.$router.push({ name: this.navigate });
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.modal_columns {
  display: grid;
  grid-template-columns: 300px 1fr;
  grid-template-rows: 1fr;
  gap: 0 0;
  grid-template-areas: "form_column slot_column";
  height: 100%;

  &--form_column {
    grid-area: form_column;
    overflow-x: auto;
    padding: $defaultGap;
    background-color: $white;
  }

  &--slot_column {
    grid-area: slot_column;
    overflow-x: auto;
    padding: 0 $defaultGap;
  }
}
</style>
